<script setup lang="ts">
import { useEventListener } from '@vueuse/core';
import throttle from 'lodash/throttle';
import { onMounted, ref } from 'vue';

import RevealMobileFilters from '@/components/search/widgets/RevealMobileFilters.vue';

const props = defineProps({
  hitSelector: { required: false, type: String, default: '.product-hit' },
});

const emit = defineEmits(['show-filters']);

const revealButton = ref(false);

const revealBottomFiltersCta = () => {
  if (window.innerWidth >= 892) return;
  const topShelf = document.querySelector<HTMLElement>('.top-shelf');
  let navOffset = topShelf?.offsetHeight ?? 0;
  const mastheadSlider = document.querySelector<HTMLElement>('.masthead #slider');
  const mobileFilterButtons = document.querySelectorAll<HTMLElement>('.reveal-filters');
  if (mobileFilterButtons.length !== 2) {
    throw new Error(
      'Expected two mobile filter buttons; must be able to offset an always-visible element',
    );
  }
  const [primaryMobileCta] = mobileFilterButtons;
  const { offsetHeight } = primaryMobileCta;
  const { top } = primaryMobileCta.getBoundingClientRect();
  if (mastheadSlider) {
    navOffset += mastheadSlider.offsetHeight;
  }
  navOffset += offsetHeight / 2;
  let revealFixedMobileMenuCta = offsetHeight + top <= navOffset;

  // finally, hide if user is scrolled past content
  const lastProduct = document.querySelector(`${props.hitSelector}:last-of-type img`);
  if (lastProduct) {
    navOffset -= offsetHeight / 2;
    const { height: imgHeight, top: imgTop } = lastProduct.getBoundingClientRect();
    if (imgHeight + imgTop <= navOffset) {
      revealFixedMobileMenuCta = false;
    }
  }
  revealButton.value = revealFixedMobileMenuCta;
};

useEventListener('resize', throttle(revealBottomFiltersCta, 100));
useEventListener('scroll', throttle(revealBottomFiltersCta, 100));
onMounted(revealBottomFiltersCta);
</script>

<template>
  <RevealMobileFilters
    :class="{ shown: revealButton }"
    isAbbreviated
    @open-filters="$emit('show-filters')"
  />
</template>
